import React from 'react';
import classes from "./FooterChildren.module.scss";
import {Link} from "stories";

const FooterChildren = () => {
    const menuItems = [
        // {
        //     title: 'Borrowers',
        //     path: '#'
        // },
        {
            title: 'Brokers',
            path: '#'
        },
        // {
        //     title: 'Lenders',
        //     path: '#',
        // },
        {
            title: 'Contact Us',
            path: '#'
        },
        {
            title: 'FAQ',
            path: '#'
        }
    ];
    return (
        <div className={'d-flex align-items-center'}>
            <ul className={classes['menu']}>
                {
                    menuItems.map(item =>
                        <li key={item.title}>
                            <Link type={'secondary'} to={item.path}>{item.title}</Link>
                        </li>
                    )
                }
            </ul>
        </div>
    );
};

export default FooterChildren;